
import { useState, useEffect } from 'react';

const useAppVersion = (requiredVersion) => {
  const [isCompatible, setIsCompatible] = useState(false);

  useEffect(() => {
    const checkVersion = () => {
      if (typeof Android !== 'undefined' && Android.onMobileAppVersionCode) {
        try {
          const androidVersion = parseInt(Android.onMobileAppVersionCode(), 10);

          if (!isNaN(androidVersion) && androidVersion >= requiredVersion) {
            setIsCompatible(true);
          } else {
            setIsCompatible(false);
          }
        } catch (error) {
          console.error('Error retrieving Android app version:', error);
          setIsCompatible(false);
        }
      } else {
        setIsCompatible(true);
      }
    };

    checkVersion();
  }, [requiredVersion]);

  return isCompatible;
};

export default useAppVersion;
